if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      updateAddToCartButton(variant) {
        // 获取当前产品表单 - 修改选择器
        const productForm = document.querySelector('form[is="product-form"]');
        if (!productForm) {
          // 尝试其他可能的选择器
          const productInfo = document.querySelector('product-info');
          if (productInfo) {
            const formId = `product-form-${productInfo.dataset.section}`;
            const form = document.getElementById(formId);
            if (form) {
              this.updateButtonText(form, variant);
              return;
            }
          }
          return;
        }

        this.updateButtonText(productForm, variant);
      }

      updateButtonText(form, variant) {
        // 获取添加按钮
        const addButton = form.querySelector('[name="add"]');
        if (!addButton) return;

        // 获取按钮文本元素
        const addButtonText = addButton.querySelector('span');
        if (!addButtonText) return;

        // 检查是否是预售商品 - inventory_quantity为undefined或小于等于0时判断为预售
        const isPreOrder = variant.inventory_quantity === undefined || variant.inventory_quantity <= 0;

        // 根据库存状态更新按钮
        if (variant.available) {
          addButton.removeAttribute('disabled');

          // 如果是预售商品，保持预售状态
          if (isPreOrder) {
            addButtonText.textContent = FoxTheme.variantStrings.preOrder;
          } else {
            // 只有在不是预售商品的情况下，才显示加入购物车
            addButtonText.textContent = FoxTheme.variantStrings.addToCart;
          }
        } else {
          addButton.setAttribute('disabled', 'disabled');
          addButtonText.textContent = FoxTheme.variantStrings.soldOut;
        }
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);

          // 获取当前选中的变体
          const variant = this.getVariantFromOptions();
          // 新增：同步更新 data-selected-variant 的内容
          const selectedVariantScript = this.querySelector('[data-selected-variant]');
          if (selectedVariantScript && variant && variant.id) {
            // 只保留和后端一致的字段
            const safeVariant = {
              id: variant.id,
              available: variant.available,
              inventory_quantity: variant.inventory_quantity,
              title: variant.title,
              sku: variant.sku,
              price: variant.price,
              compare_at_price: variant.compare_at_price,
              featured_media: variant.featured_media
            };
            selectedVariantScript.textContent = JSON.stringify(safeVariant);
          }
          // 新增：切换变体时同步更新URL
          if (variant && variant.id) {
            const url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
          if (variant) {
            this.updateAddToCartButton(variant);
          }

          // 发布选项变更事件
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      getVariantFromOptions() {
        const selectedOptions = this.selectedOptionValues;

        // 直接从variant-selects元素中获取变体数据
        const variantData = this.querySelector('[data-selected-variant]')?.textContent;
        if (!variantData) return null;

        try {
          const variant = JSON.parse(variantData);
          return variant;
        } catch (error) {
          return null;
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
